import React from "react";
import {
  getPages,
  renderPreview,
  renderVideo,
} from "../pages/SectionElements/plugins/utils";
import RenderHtml from "./AppSpecificConpnents/PartsTable/RenderHtml";
import {
  calculateGroupHeight,
  calculateTextBlockWidth,
  estimateKonvaTextHeight,
  formatListContent,
  getTextStyle,
  hasNoteContent,
  hasTaskContent,
  hasUserContent,
  stripHtmlPreserveFormatting,
} from "../pages/SectionElements/plugins/utils";
import CanvasDisplay from "../pages/Canvas/components/canvas-core/CanvasDisplay";

const DeleteContentRenderer = ({
  item,
  sectionIndex,
  globalStepNumber,
  globalSubstepLabel = null,
  counters = {},
}) => {
  const {
    richTextCounter,
    videoCounter,
    formCounter,
    canvasCounter,
    attachmentCounter,
  } = counters;

  if (!item) return null;

  const getItemLabel = () => {
    switch (item.type) {
      case "richText":
        return <h2>Rich Text {richTextCounter}</h2>;
      case "video":
        return <h2>Video {videoCounter}</h2>;
      case "form":
        return <h2>Form {formCounter}</h2>;
      case "canvas":
        return <h3>Canvas {canvasCounter}</h3>;
      case "attachment":
        return <h2>Attachment {attachmentCounter}</h2>;
      default:
        return null;
    }
  };

  const getLocationText = () => {
    if (globalSubstepLabel) {
      return `Section ${
        sectionIndex + 1
      } > Step ${globalStepNumber} > Substep ${globalSubstepLabel}`;
    }
    return `Section ${sectionIndex + 1} > Step ${globalStepNumber}`;
  };

  const renderItemContent = () => {
    switch (item.type) {
      case "richText":
        return (
          <>
            <div
              style={{
                marginLeft: "5px",
                marginTop: "-10px",
              }}
            >
              {item.short_description}
            </div>
            <div
              style={{
                marginLeft: "4px",
                marginTop: "5px",
              }}
            >
              {item.category_data?.category_name}
            </div>
            <div
              style={{
                fontSize: "14px",
                marginLeft: "4px",
                marginTop: "5px",
              }}
            >
              <div
                style={{ marginTop: "-6px" }}
                dangerouslySetInnerHTML={{
                  __html: item.rich_text_content,
                }}
              />
            </div>
          </>
        );

      case "video":
        return (
          <>
            {renderVideo(item)}
            <div>{item.video_url}</div>
            <div>{item.short_description}</div>
          </>
        );

      case "form":
        return <div>{item.short_description}</div>;

      case "canvas":
        const pages = getPages(item);
        return (
          <>
            <div>{item.short_description}</div>
            <CanvasDisplay
              pages={pages}
              hasUserContent={hasUserContent}
              getTextStyle={getTextStyle}
              stripHtmlPreserveFormatting={stripHtmlPreserveFormatting}
              estimateKonvaTextHeight={estimateKonvaTextHeight}
              formatListContent={formatListContent}
              hasNoteContent={hasNoteContent}
              hasTaskContent={hasTaskContent}
              calculateGroupHeight={calculateGroupHeight}
              calculateTextBlockWidth={calculateTextBlockWidth}
            />
          </>
        );

      case "attachment":
        const attachmentList = item.attachments || [];
        if (attachmentList.length === 0) return null;

        return (
          <>
            <div>{item.short_description}</div>
            {attachmentList.map((attachment, i) => (
              <div key={i} style={{ marginLeft: "20px" }}>
                {renderPreview(attachment)}
              </div>
            ))}
          </>
        );

      default:
        return null;
    }
  };

  const getItemKey = () => {
    switch (item.type) {
      case "richText":
        return item.rich_text_tree_node_id || `rich-text-${richTextCounter}`;
      case "video":
        return (
          item.video_tree_node_id ||
          item.video_node_id ||
          `video-${videoCounter}`
        );
      case "form":
        return (
          item.form_tree_node_id || item.form_node_id || `form-${formCounter}`
        );
      case "canvas":
        return (
          item.canvas_tree_node_id ||
          item.canvas_node_id ||
          item.canvas_tree_node_ref ||
          `canvas-${canvasCounter}`
        );
      case "attachment":
        return (
          item.attachment_tree_node_id || `attachment-${attachmentCounter}`
        );
      default:
        return `item-${Math.random()}`;
    }
  };

  return (
    <div
      className="header-spacing"
      key={getItemKey()}
      style={{ marginTop: "20px" }}
    >
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
        }}
      >
        <label
          style={{
            display: "flex",
            gap: "6px",
            cursor: "pointer",
          }}
        >
          {getItemLabel()}
        </label>

        <div
          style={{
            color: "#888",
            fontSize: "14px",
            fontWeight: "normal",
          }}
        >
          {getLocationText()}
        </div>
      </div>
      {renderItemContent()}
    </div>
  );
};

export default DeleteContentRenderer;
